"use strict";
class RenderBundle {
  /**
   * @param gpuBundle - The recorded native render bundle.
   * @param stateKey - The pipeline state key captured when recording began.
   * @param device - The device the bundle was recorded on.
   * @param label - Optional debug label for the bundle.
   */
  constructor(gpuBundle, stateKey, device, label) {
    this.gpuBundle = gpuBundle;
    this.stateKey = stateKey;
    this.device = device;
    this.label = label;
  }
}

export { RenderBundle };
//# sourceMappingURL=RenderBundle.mjs.map
